import React from 'react';
import { State } from 'store/state';
import { connect } from 'react-redux';
import { setActiveInsight } from 'store/state/insightsContext/actions';
import { setIsListingAdditionalBannerClosed, setVisibleSection, setNewUnitPageMapExpanded } from 'store/state/app/actions';
import { activeInsightIdSelector, insightsMobileMapTypeSelector } from 'store/state/insightsContext/selectors';
import {
  isUnitPageBulletinLoadingSelector,
  insightsLoadingSelector,
  resolvedLocalPagePreviewSelector,
  unitExpandSelector,
  unitPageListingWithInsightsSelector,
  hasBuildingDetailsSectionSelector,
  isEditAllowedSelector,
  isAgentConsoleUserSelector,
  userHasSubmittedInvestorsPilotFormSelector,
  userHasAcceptedInvestorsTermsSelector,
  isConnectedUserSelector,
} from 'store/state/domainData/selectors';
import { userContentTextReviewsSelector, userContentRatingReviewsSelector } from 'store/state/UGC/selectors';
import { isUnitSelector } from 'components/widget/prices';
import ResidentialListingPageUnconnected from './residential-listing';
import { isListingAdditionalBannerClosedSelector, isNewUnitPageMapExpandedSelector } from 'store/state/app/selectors';
import { hasRelatedAgentListingsSelector } from 'store/state/domainData/selectors/additionalListingCarousel';
import { HeaderWrapper } from 'ds/components/Layout';
import { noop, flow } from 'lodash';
import Navigation from 'components/navigation';
import { useIntersectionObserver } from 'hooks/useIntersectionObserver';
import { showAboutTheOfficeSectionSelector, officeDescriptionSelector, agentDescriptionSelector, residentialAgentListingsSelector } from 'store/state/domainData/selectors/agentWithBulletinsByIds';
import { residentialOfficeListingsSelector } from 'store/state/domainData/selectors/officeListings';
import { unitPageLeadingAgentSelector } from 'store/state/domainData/selectors/unit-page-leading-data';
import { createSelector } from 'reselect';
import { getRouteParams } from 'store/state/selectors/router';

const residentialActiveInsightIdSelector = createSelector([
  activeInsightIdSelector,
  isNewUnitPageMapExpandedSelector,
], (id, open) => {
  return id && !open ? id : null;
});
const isGalleryOpenSelector = flow(getRouteParams, (p) => p.activeListingImage !== undefined);

const mapStateToProps = (state: State) => ({
  bulletin: unitPageListingWithInsightsSelector(state),
  loading: isUnitPageBulletinLoadingSelector(state),
  insightsLoading: insightsLoadingSelector(state),
  activeInsightId: residentialActiveInsightIdSelector(state),
  unitExpand: unitExpandSelector(state),
  hasBuildingDetailsSection: hasBuildingDetailsSectionSelector(state),
  isUnit: isUnitSelector(state),
  localData: resolvedLocalPagePreviewSelector(state),
  ugcTextReviews: userContentTextReviewsSelector(state),
  ugcRatingReviews: userContentRatingReviewsSelector(state),
  isEditAllowed: isEditAllowedSelector(state),
  userHasSubmittedInvestorsPilotForm: userHasSubmittedInvestorsPilotFormSelector(state),
  isListingAdditionalBannerClosed: isListingAdditionalBannerClosedSelector(state),
  hasRelatedAgentListings: hasRelatedAgentListingsSelector(state),
  isNewUnitPageMapExpanded: isNewUnitPageMapExpandedSelector(state),
  showAboutTheOfficeSection: showAboutTheOfficeSectionSelector(state),
  officeListings: residentialOfficeListingsSelector(state),
  officeDescription: officeDescriptionSelector(state),
  agentDescription: agentDescriptionSelector(state),
  leadingData: unitPageLeadingAgentSelector(state),
  agentListings: residentialAgentListingsSelector(state),
  mobileInsightsType: insightsMobileMapTypeSelector(state),
  isGalleryOpen: isGalleryOpenSelector(state),
  isAgentConsoleUser: isAgentConsoleUserSelector(state),
  isUser: isConnectedUserSelector(state),
  investorsTermsAccepted: userHasAcceptedInvestorsTermsSelector(state),
});

const mapDispatchToProps = {
  setActiveInsightId: setActiveInsight,
  setVisibleSection,
  onAdditionalBannerClose: () => setIsListingAdditionalBannerClosed(true),
  setNewUnitPageMapExpanded,
};


const ConnectedListingPage = connect(mapStateToProps, mapDispatchToProps)(ResidentialListingPageUnconnected);


const ListingPageHeader: React.FC = () => {
  const topPageRef = React.useRef<HTMLDivElement>(null);
  const [ showAnimatedSubHeader, setShowAnimatedSubHeader ] = React.useState(false);

  useIntersectionObserver(([ entry ]) => {
    setShowAnimatedSubHeader(!entry.isIntersecting);
  }, [ topPageRef ], { });

  return (
    <>
      <HeaderWrapper>
        <Navigation
          useAnimatedSubheader={showAnimatedSubHeader}
          isMobileMapViewActive={false}
          setMobileMapViewActive={noop}
        />
      </HeaderWrapper>
      <div ref={topPageRef} />
      <ConnectedListingPage />
    </>
  );
};

export default ListingPageHeader;
